import { render, staticRenderFns } from "./WorkspaceBadges.vue?vue&type=template&id=7bc10d54&scoped=true&"
import script from "./WorkspaceBadges.vue?vue&type=script&lang=js&"
export * from "./WorkspaceBadges.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceBadges.vue?vue&type=style&index=0&id=7bc10d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc10d54",
  null
  
)

export default component.exports